import { useMemo, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { usePagination, useRowSelect, useTable, useFilters } from 'react-table';
// import styled from 'styled-components';
import DownloadBtn from '../../../../../../Components/Buttons/DownloadBtn';
import ReactTableRender from '../../../../../../Components/ReactTable/ReactTableRender';
import { clearTable } from '../../../../../../Redux/slices/table';
import { checkPermission } from '../../../../../../_helpers/roles/check-roles';
import DefaultColumnFilter from '../../../../../../Components/ReactTable/Filters/DefaultColumnFilter';

// const StyledDefaultColumnFilter = styled.input`
//   width: 100%;
// `;
// // Define a default UI for filtering
// const DefaultColumnFilter = ({ column: { filterValue, preFilteredRows, setFilter } }) => {
//   const count = preFilteredRows.length;
//   return (
//     <StyledDefaultColumnFilter
//       value={filterValue || ''}
//       onChange={(e) => {
//         setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
//       }}
//       placeholder={`Search ${count} records...`}
//     />
//   );
// };

function ResourcePersonListTable({
  data,
  columns,
  dataFetcher,
  active_role,
  initialState,
  showGoto = true
}) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.table.loading);
  const totalCount = useSelector((state) => state.table.totalCount);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const { id } = useParams();
  const defaultColumn = useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    }),
    []
  );

  // Use the state and functions returned from useTable to build your UI
  const {
    headerGroups,
    getTableProps,
    getTableBodyProps,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageCount,
    previousPage
  } = useTable(
    {
      columns,
      data: data,
      manualPagination: true,
      pageCount: pageNum,
      defaultCanFilter: false,
      defaultColumn,
      initialState: { ...initialState }
      // manualFilters: true
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    dataFetcher({ index: pageNum, size: pageSize });
  }, [pageNum, pageSize]);
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  const pageCountArray = useMemo(
    () => Array.from({ length: Math.ceil(totalCount / pageSize) }, (v, i) => i + 1),
    [totalCount, pageSize]
  );

  const nextPage = (page) => {
    setPageNum(page);
  };
  const gotoPage = (page) => {
    setPageNum(page);
  };

  return (
    <>
      <ReactTableRender
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        getTableBodyProps={getTableBodyProps}
        page={page}
        prepareRow={prepareRow}
        totalCount={totalCount}
        gotoPage={gotoPage}
        previousPage={previousPage}
        pageCount={pageCount}
        pageCountArray={pageCountArray}
        pageNum={pageNum}
        showGoto={showGoto}
        nextPage={nextPage}
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
        loading={loading}
        setPageSize={setPageSize}
        rightChildren={
          <div className="d-flex ps-4 justify-content-end" style={{ width: '50em' }}>
            {checkPermission(active_role, 'export files') && (
              <>
                <DownloadBtn
                  apiUrl={`/report/each-event/roster/?event_id=${id}&type=excel`}
                  type="excel"
                />
                <DownloadBtn
                  apiUrl={`/report/each-event/roster/?event_id=${id}&type=pdf`}
                  type="pdf"
                />
              </>
            )}
          </div>
        }
      />
    </>
  );
}

export default ResourcePersonListTable;
